import script from "./ButtonTwoLines.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonTwoLines.vue?vue&type=script&setup=true&lang=js"

import "./ButtonTwoLines.vue?vue&type=style&index=0&id=f80d0386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f80d0386"]])

export default __exports__